import { render, staticRenderFns } from "./ClassicEnrollment.vue?vue&type=template&id=3b6b879e&scoped=true&"
import script from "./ClassicEnrollment.vue?vue&type=script&lang=js&"
export * from "./ClassicEnrollment.vue?vue&type=script&lang=js&"
import style0 from "./ClassicEnrollment.vue?vue&type=style&index=0&id=3b6b879e&lang=scss&scoped=true&"
import style1 from "./ClassicEnrollment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6b879e",
  null
  
)

export default component.exports